import { useRef } from 'react';
import { motion } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
function scrollToSection(id: string) {
  document.getElementById(id)?.scrollIntoView({
    behavior: 'smooth'
  });
}
export function HeroSection() {
  const videoRef = useRef<HTMLVideoElement>(null);
  return <section id="hero" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Video Background */}
      <video ref={videoRef} autoPlay muted loop playsInline className="absolute inset-0 w-full h-full object-cover opacity-35" aria-hidden="true">
        <source src="/video/cinematic-mission.mp4" type="video/mp4" />
      </video>

      {/* Dark overlay gradient */}
      <div className="absolute inset-0" style={{
      background: 'linear-gradient(to bottom, rgba(0,0,0,0.5) 0%, rgba(0,0,0,0.2) 50%, var(--background) 100%)'
    }} />

      {/* Ambient glow orbs */}
      <div className="absolute top-1/3 left-1/4 w-96 h-96 rounded-full blur-3xl pointer-events-none" style={{
      background: 'radial-gradient(circle, oklch(0.65 0.18 180 / 0.15), transparent 70%)'
    }} />
      <div className="absolute bottom-1/3 right-1/4 w-80 h-80 rounded-full blur-3xl pointer-events-none" style={{
      background: 'radial-gradient(circle, oklch(0.68 0.22 25 / 0.12), transparent 70%)'
    }} />

      {/* Hero Content */}
      <div className="relative z-10 max-w-5xl mx-auto px-6 text-center">
        <motion.div initial={{
        opacity: 0,
        scale: 0.8
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} className="mb-6">
          
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.7,
        delay: 0.2
      }} className="text-5xl md:text-7xl lg:text-8xl font-bold text-foreground leading-tight mb-4" style={{
        fontFamily: "'Sora', sans-serif",
        letterSpacing: '-0.02em'
      }}>
          K.S. Score
          <span className="block text-primary">&amp; Sound</span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.7,
        delay: 0.4
      }} className="text-lg md:text-xl text-muted-foreground max-w-2xl mx-auto mb-10 leading-relaxed">
          Cinematic music composition &amp; sound design for film, television,
          games, and media — by{' '}
          <span className="text-foreground font-semibold">Konstantin Solopov</span>.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.7,
        delay: 0.55
      }} className="flex flex-col sm:flex-row gap-4 justify-center">
          <button onClick={() => scrollToSection('music')} className="px-8 py-4 rounded-xl font-semibold text-base bg-primary text-primary-foreground hover:opacity-90 transition-all duration-200 shadow-xl">
            Listen Now
          </button>
          <button onClick={() => scrollToSection('contact')} className="px-8 py-4 rounded-xl font-semibold text-base border border-border bg-card/30 text-foreground hover:bg-card/60 transition-all duration-200 backdrop-blur-sm">
            Work Together
          </button>
        </motion.div>
      </div>

      {/* Scroll indicator */}
      <motion.button onClick={() => scrollToSection('music')} initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1.2
    }} className="absolute bottom-8 left-1/2 -translate-x-1/2 text-muted-foreground hover:text-primary transition-colors animate-bounce" aria-label="Scroll down">
        <ChevronDown className="w-7 h-7" />
      </motion.button>
    </section>;
}